<template>
  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    <div>
      <Link v-bind:href="$route('dashboard')" target="_top">
        <Logo />
      </Link>
    </div>

    <div class="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
      <div class="mb-4 text-sm text-gray-600">
        Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
      </div>

      <form v-on:submit.prevent="form.post($route('password.request'))">
        <!-- Email Address -->
        <div class="form-group">
          <label for="email">
            Email
          </label>

          <input v-model="form.email" class="form-control" id="email" type="email" required="required" autofocus="autofocus">
        </div>

        <div class="flex items-center justify-end mt-4">
          <button type="submit" class="btn btn-primary">
            Email Password Reset Link
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { Link, useForm } from "@inertiajs/vue3";
import Logo from "../Layouts/Logo";

const form = useForm({
  email: null,
});
</script>
